import { ReactSVG } from 'react-svg'

import { useFavoriteCount } from '@features/favorite/hooks/useFavoriteCount'
import { useAddressStore } from '@features/shipping-methods'

import { URL_CUSTOMER_FAVORITES, URL_CUSTOMER_PROFILE } from '@shared/contants'
import { cn } from '@shared/lib/cn'
import Button from '@shared/ui/button'

import styles from './styles.module.scss'

interface FavoriteLinkProps {
  className?: string;
}

export default function FavoriteLink (props: FavoriteLinkProps) {
  const { className } = props
  const { shopId } = useAddressStore()
  const favoriteCount = useFavoriteCount(shopId)

  return (
    <Button
      className={cn(styles.link, className)}
      theme="grey"
      size="large"
      shape='square'
      to={`${URL_CUSTOMER_PROFILE}/${URL_CUSTOMER_FAVORITES}`}
    >
      <ReactSVG src="/icons/heart.svg" />

      {!!favoriteCount && (
        <span className={styles.link__count}>{favoriteCount}</span>
      )}
    </Button>
  )
}